import { render, staticRenderFns } from "./platePopup.vue?vue&type=template&id=1703ed0e&scoped=true"
import script from "./platePopup.vue?vue&type=script&lang=js"
export * from "./platePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1703ed0e",
  null
  
)

export default component.exports